import DisclosureGuidelineModal from '@Components/Bases/DisclosureGuidelineModal';
import InfoPopUpIcon from '@Components/Icons/InfoPopUpIcon';
import { useDisclosure } from '@hooks/useDisclosure';
import { Box, Button, Typography } from '@mui/material';

const DisclosureGuidelinesProductInformation = () => {
  const [opened, { open, close }] = useDisclosure();

  return (
    <Box>
      <Button color={'inherit'} startIcon={<InfoPopUpIcon />} onClick={open}>
        แนวทางการเปิดเผย
      </Button>
      <DisclosureGuidelineModal
        open={opened}
        onClose={close}
        title="ข้อมูลเกี่ยวกับผลิตภัณฑ์"
        note={
          <ul style={{ paddingLeft: '16px', listStyleType: 'disc', margin: 0 }}>
            <li style={{ marginBottom: '4px' }}>
              ตัวอักษรปกติ แสดงถึง ข้อกำหนดของแบบ Corporate Value Up
              ตามประกาศคณะกรรมการกำกับตลาดทุนว่าด้วยหลักเกณฑ์ เงื่อนไข
              และวิธีการรายงานการเปิดเผย
              ข้อมูลเกี่ยวกับฐานะการเงินและผลการดำเนินงานของบริษัทที่ออกหลักทรัพย์
            </li>
            <li>
              ตัวอักษรเอียง แสดงถึง คำอธิบาย แนวปฏิบัติ คำแนะนำ
              และตัวอย่างประกอบเพิ่มเติม
              ซึ่งจะมีคำอธิบายเฉพาะหัวข้อที่อาจมีปัญหาในทางปฏิบัติ
              หรืออาจต้องการแนวปฏิบัติหรือคำแนะนำที่ช่วยในการจัดทำแบบ Corporate
              Value up
            </li>
          </ul>
        }
        description={
          <>
            <Typography mt={2}>
              ให้อธิบายลักษณะผลิตภัณฑ์หรือบริการเพื่อให้ผู้ลงทุนเข้าใจลักษณะธุรกิจของบริษัทในปีที่ผ่านมา
              รวมถึงปัจจัยที่มีผลกระทบต่อโอกาส หรือข้อจำกัดการประกอบธุรกิจ เช่น
              การได้รับใบอนุญาตให้ประกอบธุรกิจ สัมปทาน หรือการส่งเสริมการลงทุน
              เป็นต้น พร้อมทั้งอธิบายลักษณะสิทธิประโยชน์ที่ได้รับด้วย
            </Typography>
            <br />
            <Typography>
              กรณีบริษัทหรือบริษัทย่อยประกอบธุรกิจที่มีลักษณะเป็นโครงการ เช่น
              ธุรกิจพัฒนาอสังหาริมทรัพย์ หรือธุรกิจโรงไฟฟ้า เป็นต้น
              ขอให้อธิบายข้อมูลของแต่ละโครงการที่มีนัยสำคัญ เช่น
              ที่ต้ังโครงการลักษณะลูกค้ากลุ่มลูกค้าเป้าหมาย มูลค่าโครงการ
              ความคืบหน้าของการพัฒนาและการขาย เป็นต้น
            </Typography>
            <br />
            <Typography sx={{ textDecoration: 'underline' }}>
              คำแนะนำ หรือคำอธิบายเพิ่มเติม
            </Typography>
            <Typography>
              การเปิดเผยการส่งเสริมการลงทุนให้เปิดเผยเฉพาะที่มีนัยสำคัญ เช่น
              สิทธิประโยชน์ด้านภาษีเงินได้นิติบุคคล
              ส่วนการส่งเสริมการลงทุนด้านอื่นสามารถสรุปให้เห็นภาพรวมได้โดยที่ไม่ต้องแจกแจงรายการ
            </Typography>
          </>
        }
      />
    </Box>
  );
};

export default DisclosureGuidelinesProductInformation;
